import { Expose } from "class-transformer";

export default class GoogleOauth {
  @Expose({ name: "auth_uri" })
  authUri: string;

  @Expose({ name: "updated_at" })
  updatedAt: string;
}
